import * as pdfjsLib from 'pdfjs-dist';
import { pdfjs } from 'react-pdf';

// Set worker source to a local file
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry'); 